/**
 * Shared utilities for slot rendering
 */

import {SliderKeyboardOperation} from '@wandb/weave/common/util/media';

import {useDetectPanelVariant} from '../../../Panel/hooks/hooks';
import {MediaConfigWithDefaults} from '../../Component';

/**
 * Hook that returns keyboard bindings for step slider when in full screen mode.
 *
 * Only includes bindings when panel is viewed in full screen to avoid
 * conflicts with global keyboard shortcuts.
 *
 * @returns Keyboard bindings object or undefined if not in full screen
 */
export const useStepSliderKeyboardBindings = () => {
  const {isFullScreenPanelPage} = useDetectPanelVariant();

  return isFullScreenPanelPage
    ? {
        'Meta+ArrowRight': SliderKeyboardOperation.INCREMENT,
        'Meta+ArrowLeft': SliderKeyboardOperation.DECREMENT,
        'Control+ArrowRight': SliderKeyboardOperation.INCREMENT,
        'Control+ArrowLeft': SliderKeyboardOperation.DECREMENT,
      }
    : undefined;
};

/**
 * Determines which axes are currently active based on the config mode.
 *
 * @param config - Media panel configuration
 * @returns Array of active axis names (e.g., ['step'], ['step', 'run'])
 */
export const getActiveAxes = (config: MediaConfigWithDefaults): string[] => {
  const mode = config.mode ?? 'gallery';
  const galleryAxis = config.gallerySettings?.axis ?? 'step';
  const gridXAxis = config.gridSettings?.xAxis ?? 'step';
  const gridYAxis = config.gridSettings?.yAxis ?? 'run';

  return mode === 'gallery' ? [galleryAxis] : [gridXAxis, gridYAxis];
};
